import { EnabledFeature } from '@givelify/api';
import {
    SetMenuItems,
    SET_MENU_ITEMS,
    SetEnabledFeatures,
    SystemState,
    SET_ENABLED_FEATURES,
    SHOW_LOADER,
    ShowLoader,
    ToggleNestedMenuItem,
    SET_SNAP_TO_GIVE_QR_CODE_URL,
    TOGGLE_NESTED_MENU_ITEM,
    SET_ONLINE_GIVING_URLS,
    IncompletePrimaryRepresentative,
    SET_INCOMPLETE_FORM_PRIMARY_REP,
    SetIncompleteFormPrimaryRep,
    SanpToGiveResponse,
} from './types';

export const setMenuItems = (
    menuItems: SystemState['menuItems'],
): SetMenuItems => {
    return {
        type: SET_MENU_ITEMS,
        menuItems,
    };
};

export const setEnabledFeatures = (
    enabledFeatures: EnabledFeature[],
): SetEnabledFeatures => ({
    type: SET_ENABLED_FEATURES,
    enabledFeatures: enabledFeatures,
});

export const showLoader = (loading: boolean): ShowLoader => ({
    type: SHOW_LOADER,
    loading,
});

export const toggleNestedMenuItem = (id: string): ToggleNestedMenuItem => ({
    type: TOGGLE_NESTED_MENU_ITEM,
    id,
});

export const setSnapToGiveQRCodeURL = (response: SanpToGiveResponse) => ({
    hasSnapToGive: response.hasSnapToGive,
    type: SET_SNAP_TO_GIVE_QR_CODE_URL,
    url: response.url,
    downloadUrl: response.downloadUrl,
});

export const setOnlineGivingURLs = (response) => ({
    type: SET_ONLINE_GIVING_URLS,
    onlineGivingURLs: response.data,
});

export const setIncompleteDoneePrimaryRep = (
    incompletePrimaryRepInfo: IncompletePrimaryRepresentative,
): SetIncompleteFormPrimaryRep => ({
    type: SET_INCOMPLETE_FORM_PRIMARY_REP,
    incompletePrimaryRepInfo,
});
